import React, {useState} from 'react'


function TextForm(props) {
    const [text, setText] = useState("");

    const handleUpClick = ()=>{
        let newText = text.toUpperCase();
        setText(newText);
    }

    const handleCapitalize = ()=>{
        let words =  text.split(" ").map(word => {
            return word.charAt(0).toUpperCase()+word.slice(1);
        })
        let newText = words.join(" ");
        setText(newText);
    }

    const handleExtraSpace = ()=>{
        let newText = text;
        newText = newText.replace(/\s+/g," ");
        setText(newText);
    }

    const handleCopyClick = ()=>{
        navigator.clipboard.writeText(text);
    }

    const handleClearClick = ()=>{
        let newText = "";
        setText(newText);
    }

    const handleLoClick = () =>{
        let newText = text.toLowerCase();
        setText(newText);
    }

    const handleOnChange = (event)=>{
        setText(event.target.value);
    }

    return (
     <>
        <div className="container" style={{color: props.mode==="light"?"#042743":"white"}}>
            <h1>{props.heading}</h1>
            <div className="mb-3 my-3">
            <textarea className="form-control" value={text} onChange={handleOnChange} id="myBox" rows="10" style={{backgroundColor: props.mode==="light"?"white":"gray", color: props.mode==="dark"?"white":"black"}}></textarea>
            </div>
            <div className="btn btn-primary mx-1 my-1" onClick={handleClearClick}>Clear</div>
            <div className="btn btn-primary mx-1 my-1" onClick={handleCopyClick}>Copy</div>
            <div className="btn btn-primary mx-1 my-1" onClick={handleUpClick}>Upper-Case</div>
            <div className="btn btn-primary mx-1 my-1" onClick={handleLoClick}>Lower-Case</div>
            <div className="btn btn-primary mx-1 my-1" onClick={handleExtraSpace}>Remove Extra Space</div>
            <div className="btn btn-primary mx-1 my-1" onClick={handleCapitalize}>Capitalize</div>
        </div>

        <div className="container" style={{color: props.mode==="light"?"#042743":"white"}}>
            <h3 className="my-3">Total words and characters count.</h3>
            <p>{text.split(" ").filter((elem)=>{
                if(elem.length!==0){
                    return elem;
                }
            }).length} words and {text.length} characters.</p>
            <h3>Preview</h3>
            <p>{text}</p>
        </div>
     </>
  )
}

export default TextForm
